module.exports = __webpack_public_path__ + "static/JosefinSans-Regular-5b0d18528d7e0b572f3fb781d3e92650.woff2";